import { FooterSubscribe } from '../FooterSubscribe';
import { FormattedMessage } from 'dibs-react-intl';
import { ConnectRow } from '../ConnectRow/ConnectRow';
import { SocialLinkRow } from '../SocialLinkRow/SocialLinkRow';
import { socialLinks } from '../links';
import { FooterLink } from '../FooterLinkTypes';

export const blog: FooterLink = {
    linkName: 'blog',
    trackingLabel: 'Blog',
    href: 'https://www.1stdibs.com/blogs/the-study/',
    dataTn: 'footer-blog',
    message: <FormattedMessage id="dbl.Footer.site_links_blog" defaultMessage="Blog" />,
};

export const magazine: FooterLink = {
    linkName: 'magazine',
    trackingLabel: 'Magazine',
    href: 'https://www.1stdibs.com/introspective-magazine/',
    dataTn: 'footer-magazine',
    message: <FormattedMessage id="dbl.Footer.site_links_magazine" defaultMessage="Magazine" />,
};

export const connectLinks: FooterLink[] = [
    {
        linkName: 'subscribe',
        CustomComponent: FooterSubscribe,
        dataTn: 'footer-subscribe',
        disablerKey: 'disableFooterSubscribe',
    },
    {
        linkName: 'connect',
        CustomComponent: ConnectRow,
        items: socialLinks,
        dataTn: 'connect-row',
    },
];

export const ampConnectLinks: FooterLink[] = [
    {
        linkName: 'amp-social-icons',
        CustomComponent: SocialLinkRow,
        items: socialLinks,
        dataTn: 'social-link-row',
    },
    blog,
    magazine,
];
